<template>
	<SegmentedToggle class="view-toggle" :model-value="modelValue" :options="options" @update:model-value="select" />
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import SegmentedToggle from "@/components/ui/SegmentedToggle.vue"
import { IconName } from "@/components/icons/registry"
import { Mode } from "@/model/RootStore"
import { analytics } from "@/utils/analytics"

defineProps<{
	modelValue: Mode
}>()

const emit = defineEmits<{
	"update:modelValue": [Mode]
}>()

const { t } = useI18n()

const options = computed(() => [
	{ value: Mode.Map, label: t("view-map"), icon: IconName.Layers },
	{ value: Mode.Table, label: t("view-table"), icon: IconName.TableList },
])

function select(mode: Mode): void {
	analytics.navigationClicked(mode === Mode.Table ? "view-table" : "view-map")
	emit("update:modelValue", mode)
}
</script>

<style scoped>
.view-toggle {
	box-shadow: var(--shadow-md);
}
</style>
